import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class AuthMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AuthMetaModule,
            providers: [
                providePageMeta({
                    title: 'Login',
                    translationKey: 'page_login',
                    routerLink: '/',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Login',
                    translationKey: 'page_login',
                    routerLink: '/account',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Login',
                    translationKey: 'page_login',
                    routerLink: '/account/login',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Reset Password',
                    translationKey: 'page_reset_password',
                    routerLink: '/account/passwordreset',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Password Change',
                    translationKey: 'page_password_change',
                    routerLink: '/account/passwordchange',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Password Reset',
                    translationKey: 'page_password_reset',
                    routerLink: '/account/passwordreset',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Password Expired',
                    translationKey: 'page_password_expired',
                    routerLink: '/account/passwordexpired',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Email Confirmation',
                    translationKey: 'page_email_confirmation',
                    routerLink: '/account/emailconfirmation',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Become a tenant',
                    translationKey: 'page_register_tenant',
                    routerLink: '/account/registertenant',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Tenant Select',
                    translationKey: 'page_tenant_select',
                    routerLink: '/account/tenantselect',
                    category: PageCategory.Unauthorized,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
